import { cloneDeep, clone } from 'lodash'
import create, { SetState, StateCreator, StoreApi } from 'zustand'

type Params = {
    page: number,
    limit: number,
    sortBy?: string,
    sortType?: 'ASC' | 'DESC'
}

type Filter = {
    columnName: string,
    searchText: string
}

export interface ReferralsStore {
    referrals : any,
    setReferrals: (x: any) => void,
    selectedPalliativeWorkerDetails : any,
    setSelectedPalliativeWorkerDetails: (x: any) => void,
    primaryUserRole : any,
    setPrimaryUserRole: (x: any) => void,
    currentCmModalVisibility : any,
    setCurrentCmModalVisibility: (x: any) => void,
    clearStore: () => void
}



let  store: StateCreator<ReferralsStore, [], [], ReferralsStore> | StoreApi<ReferralsStore> = (set: SetState<ReferralsStore>) => ({
    
    referrals: {},
    setReferrals: (referrals : any) => {
        set(state => ({ referrals }))
    },
    selectedPalliativeWorkerDetails: {},
    setSelectedPalliativeWorkerDetails:(selectedPalliativeWorkerDetails : any) => {
        set(state => ({ selectedPalliativeWorkerDetails }))
    },
    primaryUserRole: {},
    setPrimaryUserRole:(primaryUserRole : any) => {
        set(state => ({ primaryUserRole }))
    },
    currentCmModalVisibility: false,
    setCurrentCmModalVisibility:(currentCmModalVisibility : any) => {
        set(state => ({ currentCmModalVisibility }))
    },
    clearStore: () => {
        set(() => ({referrals: {}}))
        set(() => ({selectedPalliativeWorkerDetails: {}}))
        set(() => ({primaryUserRole: {}}))
        set(() => ({currentCmModalVisibility: false}))
    }
})


export const useReferralsStore  = create(store)
